const MATERIAL_NAMES: readonly string[] = [
  'Grass',       // 0
  'Stone',       // 1
  'Wood',        // 2
  'Tile',        // 3
  'Dirt',        // 4
  'Sand',        // 5
  'Water',       // 6
  'Tilled Soil', // 7
  'Cobblestone', // 8
  'Snow',        // 9
  'Mud',         // 10
  'Clay',        // 11
  'Carpet',      // 12
  'Marble',      // 13
  'Path',        // 14
];

export function materialLabel(id: number): string {
  return MATERIAL_NAMES[id] ?? `Material #${id}`;
}

const BIOME_NAMES: readonly string[] = [
  'Grassland',  // 0
  'Forest',     // 1
  'Coast',      // 2
  'Desert',     // 3
  'Tundra',     // 4
  'Swamp',      // 5
  'Mountain',   // 6
  'Ocean',      // 7
];

export function biomeLabel(id: number): string {
  return BIOME_NAMES[id] ?? `Biome #${id}`;
}

export function elevationBand(elevation: number): string {
  if (elevation <= 61) return 'Lowland';
  if (elevation <= 140) return 'Midland';
  if (elevation <= 210) return 'Highland';
  if (elevation <= 250) return 'Alpine';
  return 'Peak';
}

const CROP_STAGES: readonly string[] = [
  'Tilled',      // 0
  'Seedling',    // 1
  'Growing',     // 2
  'Mature',      // 3
  'Harvestable', // 4
  'Withered',    // 5
];

export function cropStageLabel(visualState: number): string {
  return CROP_STAGES[visualState] ?? `Stage ${visualState}`;
}

export function freshnessLabel(machineState: string | null): string | null {
  switch (machineState) {
    case 'fresh': return 'Fresh';
    case 'stale': return 'Stale';
    case 'spoiled': return 'Spoiled';
    case 'rotten': return 'Rotten';
    default: return null;
  }
}

export function moistureLabel(value: number, received: boolean): string {
  if (!received) return '—';
  if (value === 0) return 'Dry';
  if (value <= 50) return 'Damp';
  if (value <= 120) return 'Moist';
  if (value <= 200) return 'Wet';
  return 'Saturated';
}

export function phaseLabel(phase: string): string {
  return phase;
}

export function seasonIcon(season: string): string {
  switch (season) {
    case 'Spring': return '☀';
    case 'Summer': return '☀';
    case 'Autumn': return '\u{1F342}';
    case 'Winter': return '❄';
    default: return '';
  }
}

const WIND_DIRS = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'] as const;

export function windDirectionLabel(degrees: number): string {
  const idx = Math.round(((degrees % 360) + 360) % 360 / 45) % 8;
  return WIND_DIRS[idx] ?? 'N';
}
